export default __webpack_public_path__ + "c1eb099102c61f867490c58027e1ddf3.png";